export const home_tab = "GSa";
export const folder_tab = "HSa";
export const view_tab = "ISa";
export const message_tab = "JSa";
export const insert_tab = "KSa";
export const format_tab = "LSa";
export const options_tab = "MSa";
export const notes_tab = "NSa";
export const format_table_tab = "OSa";
export const poll_Button = "PSa";
export const table_Button = "QSa";
export const pictures_Button = "RSa";
export const emojis_Button = "SSa";
export const newItems_FlyoutButton = "TSa";
export const newMessage_Button = "USa";
export const newPost_Button = "VSa";
export const newEMailMessage_Button = "WSa";
export const newCalEvent_Button = "XSa";
export const newContact_Button = "YSa";
export const newTask_Button = "ZSa";
export const newTeamsMtg_Button = "_Sa";
export const ignoreEmail_Button = "$Sa";
export const stopIgnoringEmail_Button = "aTa";
export const cleanUp_FlyoutButton = "bTa";
export const junk_FlyoutButton = "cTa";
export const blockSender_Button = "dTa";
export const junk_Button = "eTa";
export const notJunk_Button = "fTa";
export const junkOptions_Button = "gTa";
export const archiveEmail_Button = "hTa";
export const sweepEmail_Button = "iTa";
export const replyToEmail_Button = "jTa";
export const replyAllToEmail_Button = "kTa";
export const replyForwardEmail_Button = "lTa";
export const replyForwardEmailAsAttachment_Button = "mTa";
export const replyMeetingToEmail_Button = "nTa";
export const readUnread_Button = "oTa";
export const pinUnpin_Button = "pTa";
export const highImportance_Button = "qTa";
export const lowImportance_Button = "rTa";
export const sendReceiveAllFolders_Button = "sTa";
export const sendAll_Button = "tTa";
export const updateFolder_Button = "uTa";
export const showSyncProgress_Button = "vTa";
export const cancelSync_Button = "wTa";
export const workOffline_Button = "xTa";
export const downloadHeaders_Button = "yTa";
export const move_FlyoutButton = "zTa";
export const moveToOtherFolder_Button = "ATa";
export const copyToOtherFolder_Button = "BTa";
export const moveAlwaysToOtherFolder_Button = "CTa";
export const moveToNewFolderPlaceholderText = "DTa";
export const rules_FlyoutButton = "ETa";
export const createRule_Button = "FTa";
export const manageRules_Button = "GTa";
export const assignPolicy_FlyoutButton = "HTa";
export const archivePolicy1Year_button = "ITa";
export const archivePolicy5Years_button = "JTa";
export const archivePolicyNever_button = "KTa";
export const archivePolicyUseFolder_button = "LTa";
export const retentionPolicy1week_button = "MTa";
export const retentionPolicy1month_button = "NTa";
export const retentionPolicy6months_button = "OTa";
export const retentionPolicy1year_button = "PTa";
export const retentionPolicy5years_button = "QTa";
export const retentionPolicyNever_button = "RTa";
export const retentionPolicyUseFolder_button = "STa";
export const moreRetentionPolicies_button = "TTa";
export const setFolderPolicy_button = "UTa";
export const viewExpiringItems_button = "VTa";
export const categorize_FlyoutButton = "WTa";
export const clearCategories_button = "XTa";
export const allCategories_button = "YTa";
export const setQuickCategories_button = "ZTa";
export const sendReceiveGroups_Button = "_Ta";
export const addReminder_Button = "$Ta";
export const markComplete_Button = "aUa";
export const clearFlag_Button = "bUa";
export const setQuickClick_Button = "cUa";
export const setQuickActions_Button = "dUa";
export const addressBook_Button = "eUa";
export const readAloud_Button = "fUa";
export const getAddIns_Button = "gUa";
export const insights_Button = "hUa";
export const reportMessage_Button = "iUa";
export const immersiveReader_Button = "jUa";
export const printMail_Button = "kUa";
export const snooze_Button = "lUa";
export const undo_Button = "mUa";
export const flagUnflag_Button = "nUa";
export const flagCompleteToday_Button = "oUa";
export const flagCompleteTomorrow_Button = "pUa";
export const flagCompleteThisWeek_Button = "qUa";
export const flagCompleteNextWeek_Button = "rUa";
export const flagCompleteNoDate_Button = "sUa";
export const flagMarkComplete_Button = "tUa";
export const flagClearFlag_Button = "uUa";
export const phishing_Button = "vUa";
export const block_Button = "wUa";
export const toggleLeftPane_Button = "xUa";
export const paste_FlyoutButton = "yUa";
export const cut_Button = "zUa";
export const copy_Button = "AUa";
export const formatPainter_Button = "BUa";
export const checkNames_Button = "CUa";
export const attachFile_FlyoutButton = "DUa";
export const attachLink_FlyoutButton = "EUa";
export const attachSig_FlyoutButton = "FUa";
export const attachSig_Button = "GUa";
export const dictate_Button = "HUa";
export const encrypt_FlyoutButton = "IUa";
export const encrypt_FlyoutTitle = "JUa";
export const encrypt_clearPermissionsButton = "KUa";
export const save_Button = "LUa";
export const sensitivity_FlyoutButton = "MUa";
export const ribbonCustomizer_Button = "NUa";
export const insertLink_Button = "OUa";
export const newNote_HeroButton = "PUa";
export const newNote_MenuButton = "QUa";
export const signatureOptions_Button = "RUa";
export const browseGroups_Button = "SUa";
export const addGroup_Button = "TUa";
export const newGroup_Button = "UUa";
export const moreRetentionPoliciesOptions_Button = "VUa";
export const viewSettings_Button = "WUa";
export const conversations_Button = "XUa";
export const messagePreview_Button = "YUa";
export const layout_Button = "ZUa";
export const folder_Button = "_Ua";
export const folderMenu_Show = "$Ua";
export const folderMenu_Hide = "aVa";
export const density_Button = "bVa";
export const manageQuickSteps_Button = "cVa";
export const messages_Button = "dVa";
export default {home_tab,folder_tab,view_tab,message_tab,insert_tab,format_tab,options_tab,notes_tab,format_table_tab,poll_Button,table_Button,pictures_Button,emojis_Button,newItems_FlyoutButton,newMessage_Button,newPost_Button,newEMailMessage_Button,newCalEvent_Button,newContact_Button,newTask_Button,newTeamsMtg_Button,ignoreEmail_Button,stopIgnoringEmail_Button,cleanUp_FlyoutButton,junk_FlyoutButton,blockSender_Button,junk_Button,notJunk_Button,junkOptions_Button,archiveEmail_Button,sweepEmail_Button,replyToEmail_Button,replyAllToEmail_Button,replyForwardEmail_Button,replyForwardEmailAsAttachment_Button,replyMeetingToEmail_Button,readUnread_Button,pinUnpin_Button,highImportance_Button,lowImportance_Button,sendReceiveAllFolders_Button,sendAll_Button,updateFolder_Button,showSyncProgress_Button,cancelSync_Button,workOffline_Button,downloadHeaders_Button,move_FlyoutButton,moveToOtherFolder_Button,copyToOtherFolder_Button,moveAlwaysToOtherFolder_Button,moveToNewFolderPlaceholderText,rules_FlyoutButton,createRule_Button,manageRules_Button,assignPolicy_FlyoutButton,archivePolicy1Year_button,archivePolicy5Years_button,archivePolicyNever_button,archivePolicyUseFolder_button,retentionPolicy1week_button,retentionPolicy1month_button,retentionPolicy6months_button,retentionPolicy1year_button,retentionPolicy5years_button,retentionPolicyNever_button,retentionPolicyUseFolder_button,moreRetentionPolicies_button,setFolderPolicy_button,viewExpiringItems_button,categorize_FlyoutButton,clearCategories_button,allCategories_button,setQuickCategories_button,sendReceiveGroups_Button,addReminder_Button,markComplete_Button,clearFlag_Button,setQuickClick_Button,setQuickActions_Button,addressBook_Button,readAloud_Button,getAddIns_Button,insights_Button,reportMessage_Button,immersiveReader_Button,printMail_Button,snooze_Button,undo_Button,flagUnflag_Button,flagCompleteToday_Button,flagCompleteTomorrow_Button,flagCompleteThisWeek_Button,flagCompleteNextWeek_Button,flagCompleteNoDate_Button,flagMarkComplete_Button,flagClearFlag_Button,phishing_Button,block_Button,toggleLeftPane_Button,paste_FlyoutButton,cut_Button,copy_Button,formatPainter_Button,checkNames_Button,attachFile_FlyoutButton,attachLink_FlyoutButton,attachSig_FlyoutButton,attachSig_Button,dictate_Button,encrypt_FlyoutButton,encrypt_FlyoutTitle,encrypt_clearPermissionsButton,save_Button,sensitivity_FlyoutButton,ribbonCustomizer_Button,insertLink_Button,newNote_HeroButton,newNote_MenuButton,signatureOptions_Button,browseGroups_Button,addGroup_Button,newGroup_Button,moreRetentionPoliciesOptions_Button,viewSettings_Button,conversations_Button,messagePreview_Button,layout_Button,folder_Button,folderMenu_Show,folderMenu_Hide,density_Button,manageQuickSteps_Button,messages_Button};